<template>
  <div class="contactus-container">
    <module1 />
    <module2 />
  </div>
</template>

<script>
import module1 from "./module1.vue";
import module2 from "./module2.vue";

export default {
  name: "ContactUsPage",
  components: {
    module1,
    module2,
  },
};
</script>

<style scoped>
.contactus-container {
  display: flex;
  flex-direction: column;
}
</style>